import absoluteUrl from '@lib/routes/helpers/absoluteUrl'
import urlWithQueryParams from '@lib/routes/helpers/urlWithQueryParams'
import { FILTER_VISIBILE } from '@modules/trials/search/const'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

export const useToggleFilterModal = () => {
  const pathname = usePathname() ?? ''
  const router = useRouter()
  const searchParams = useSearchParams() ?? new URLSearchParams()

  return () => {
    const params = new URLSearchParams(searchParams?.toString() ?? '')
    const isVisible = params.get(FILTER_VISIBILE) === 'true'

    if (isVisible) {
      params.delete(FILTER_VISIBILE)
    } else {
      params.set(FILTER_VISIBILE, 'true')
    }

    router.push(absoluteUrl(urlWithQueryParams(pathname, params)))
  }
}
